import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ApprovalRequests from "../../Sections/Approval/ApprovalRequests";


const ApprovalsComponent = () => {
    return (
        <Dashboard sectionName={<ApprovalRequests />} />
    );
};

export default ApprovalsComponent

